/**
 * FormCard
 * White card container with OPOS border styling.
 * Used to group related form sections on both survey pages.
 */
export default function FormCard({ children, className = '' }) {
    return (
        <div
            className={`rounded-lg p-4 mb-3 ${className}`}
            style={{ background: 'white', border: '0.5px solid #d8eaf5' }}
        >
            {children}
        </div>
    );
}
